<template>
  <div id="medication-recommendation-form-dataset">
    
    <div>
      <!-- Medication Table -->
      <h3 class="grey--text text--darken-3 mt-10 d-flex">
        <span>Medication <small><i>(Click a record to update)</i></small></span>
        <base-popup-btn
          v-if="consultation.status != 'submitted'"
          class="ml-auto"
          @click="addMedication"
        >
          Add Medication
        </base-popup-btn>
      </h3>
      
      <v-row>
        <v-col cols="12">
          <base-table
            :headers="medicationHeaders"
            :items="medications"
            class="table table-striped"
          >
            <template v-slot:item="{ item }">
              <tr :id="'medication-instance-' + item.medication_index" @click="updateMedication(item.medication_index)">
                <td>{{ item.medicine_id }}</td>
                <td>{{ item.brand }}</td>
                <td>{{ item.generic }}</td>
                <td>{{ item.strength }}</td>
                <td>{{ item.quantity }}</td>
                <td v-if="item.instruction.take">
                  Take {{ item.instruction.take.quantity + ' ' + item.instruction.take.label }}&nbsp;
                    every {{ item.instruction.every.quantity + ' ' + item.instruction.every.label }}&nbsp;
                    for {{ item.instruction.for.quantity + ' ' + item.instruction.for.label }}
                </td>
                <td v-else>
                  {{ item.instruction }}
                </td>
                <td>{{ item.created_on }}</td>
                <td class="text-capitalize">{{ item.record_type }}</td>
                <!-- <td>
                  <v-checkbox
                    :value="true"
                    hide-details
                    dense
                    @click.stop
                  ></v-checkbox>
                </td> -->
              </tr>
            </template>
          </base-table>
        </v-col>
      </v-row>

      <p>&nbsp;</p>
      <hr />
      <p>&nbsp;</p>

    </div>



    <!-- ########################################################### Recommendation Table ########################################################### -->

    <h3 class="grey--text text--darken-3 mt-10 d-flex">
      <span>Recommendation <small><i>(Click a record to update)</i></small><span class="red--text">*</span></span>
      <base-popup-btn
        v-if="consultation.status != 'submitted'"
        class="ml-auto"
        @click="addRecommendation"
      >
        Add Recommendation
      </base-popup-btn>
    </h3>
    <p v-if="!recommendations.length" class="error-text">This field is required.</p>

    <v-row>
      <v-col cols="12">
        <base-table
          :headers="recommendationHeaders"
          :items="recommendations"
          @click:row="updateRecommendation"
        >
          <template v-slot:item="{ item }">
            <tr :id="'recommendation-instance-' + item.recommendation_index" @click="updateRecommendation(item.recommendation_index)">
              <td>{{ item.point_of_care }}</td>
              <td>{{ item.time_to_treat }}</td>
              <td>{{ item.recommended_action }}</td>
              <td>{{ item.created_on }}</td>
              <td class="text-capitalize">{{ item.record_type }}</td>
            </tr>
          </template>
        </base-table>

        <div style="width: 100%; text-align: center; color: red; padding: 15px;" v-show="elementVisible" class="error-message"><h3>{{ errorMessage }}</h3></div>

      </v-col>
    </v-row>

    <!-- ########################################################### Recommendation Table ########################################################### -->




    <!-- DIALOGS -->
  
    <!-- Medication Dialog -->
    <v-dialog 
      v-model="medicationDialog"
      content-class="elevation-0"
      width="85vw"
      max-width="850px"
    >
      <v-row
        dense
        class="fill-height"
        align="center"
      >
        <v-col cols="12">
          <v-row
            dense
            justify="center"
          >
            <!-- Profile card -->
            <MedicationProfileCard :patient="patient" />

            <!-- Medication Card -->
            <v-col cols="12" md="8">
              <v-form ref="medicationForm" v-model="medicationFormValid">
                <v-card
                  height="90vh"
                  max-height="750px"
                  rounded="lg"
                  class="px-5"
                >
                  <v-card-title class="primary--text">Medication</v-card-title>
                  <v-card-text style="height:80%" class="overflow-y">
                    <!-- Medication search -->
                    <v-autocomplete
                      ref="medicineAutoComplete"
                      :loading="isLoading"
                      placeholder=" "
                      :items="medicines"
                      item-text="brand_name"
                      item-value="id"
                      v-model="medicine_id"
                      :rules="rules.required"
                      @change="addToMostUsed"
                      @keypress="isSearching = true"
                      @keydown="isSearching = false"
                      @click:clear="isSearching=false"
                      :search-input.sync="filter"
                      :filter="filterObject"
                      clearable
                      hide-no-data
                      hide-selected
                      :menu-props="{ maxHeight: 450 }"
                      v-on:focus="() => {this.$vtt.startSpeechListener((text) => { this.setCode(text); }, 'medicine_id')}"
                      v-on:click="() => {this.$vtt.setModel('medicine_id');}"
                    >
                      <template v-slot:label>
                        <h3>Medication Search <span class="red--text">*</span></h3>
                      </template>

                      <template v-slot:append>
                        <v-icon>mdi-magnify</v-icon>
                      </template>

                      <!-- ##################################### favorites panel ##################################### -->

                      <template v-if="!isSearching" v-slot:prepend-item>
                        <favorites-panel>
                          <div v-if="favoriteMedicines.length > 0">
                            <v-data-table
                              :items="favoriteMedicines"
                              class="sticky mt-5 v-table-max-width"
                              :disable-sort="true"
                            >
                            <template v-slot:item="{ key, item }">
                              <tr>
                                <!-- Row Name -->
                                <td>
                                  <medicine-item
                                    :item="item"
                                    :key="key"
                                    panel-view
                                    @click="setSelected(item, 'fav')"
                                  />
                                </td>
                              </tr>
                            </template>
                          </v-data-table>
                          </div>
                          <div v-if="favoriteMedicines.length == 0" class="text-center pt-5 mt-5">
                            <span class="pt-5 mt-5">No favorite medications added yet.</span>
                          </div>
                        </favorites-panel>

                        <!-- <hr style="border-top: 1px solid #cccccc;" /> -->

                        <!-- ##################################### favorites panel ##################################### -->





                        <!-- ##################################### most used panel ##################################### -->
                        
                        <!-- <most-used-panel>
                          <template v-for="(item, key) in mostUsedMedicines">
                            <medicine-item
                              :item="item"
                              :key="key"
                              panel-view
                              @click="setSelected(item, 'used')"
                            >
                            </medicine-item>
                          </template>
                        </most-used-panel> -->
                      </template>

                      <!-- ##################################### most used panel ##################################### -->




                      <!-- ####################################### pagination ####################################### -->

                      <template v-slot:append-item>
                        <hr style="border-top: 1px solid #cccccc;">

                        <div class="d-flex mt-3 mb-1">
                          <v-btn
                            small
                            depressed
                            rounded
                            color="primary"
                            class="mx-2 px-4 text-none"
                            @click="togglePage('prev')"
                            :disabled="page==1"
                          >
                            Prev
                          </v-btn>

                          <v-spacer style="text-align: center;">Page {{page}} / {{ last_page }}</v-spacer>

                          <v-btn
                            small
                            depressed
                            rounded
                            color="primary"
                            class="mx-2 px-4 text-none"
                            @click="togglePage('next')"
                            :disabled="last_page==page"
                          >
                            Next
                          </v-btn>
                        </div>
                      </template>

                      <!-- ####################################### pagination ####################################### -->




                      <!-- ################################### default selection #################################### -->

                      <template v-slot:item="data">
                        <medicine-item :item="data.item"></medicine-item>
                      </template>

                      <!-- ################################### default selection #################################### -->



                    </v-autocomplete>

                    <!-- {{ medicine_id }} -->

                    <!-- Brand Name -->
                    <v-text-field 
                      v-model="brand" 
                      placeholder=" " 
                      :rules="rules.required"
                      v-on:focus="() => {this.$vtt.startSpeechListener((text) => { this.brand = `${this.brand || ''} ${text}`;}, 'brand')}"
                      v-on:click="() => {this.$vtt.setModel('brand');}"
                      @input="setHint(brand, (replacement) => { brand = replacement })"
                      @keydown.tab="(e) => {
                        if (!getReplacement(brand)) { return true; } else { e.preventDefault(); brand = getReplacement(brand); clearReplacement(); }
                      }"
                      >
                      <template v-slot:label>
                        <h3>Brand Name <small style="color: red;">(Type in the word HIDE if you want it hidden in documents)</small></h3>
                      </template>
                    </v-text-field>

                    <!-- Generic Name -->
                    <v-text-field 
                      v-model="generic" 
                      placeholder=" " 
                      :rules="rules.required"
                      v-on:focus="() => {this.$vtt.startSpeechListener((text) => { this.generic = `${this.generic || ''} ${text}`;}, 'generic')}"
                      v-on:click="() => {this.$vtt.setModel('generic');}"
                      @input="setHint(generic, (replacement) => { generic = replacement })"
                      @keydown.tab="(e) => {
                        if (!getReplacement(generic)) { return true; } else { e.preventDefault(); generic = getReplacement(generic); clearReplacement(); }
                      }"
                      >
                      <template v-slot:label>
                        <h3 class="">Generic Name <span class="red--text">*</span></h3>
                      </template>
                    </v-text-field>
                    
                    <v-row>

                      <v-col v-if="strenght_quantity_error" cols="12" class="py-0"><span class="red--text"><h3>{{ strenght_quantity_error }}</h3></span></v-col>

                      <!-- Strength/Preparation -->
                      <v-col cols="6" class="py-0">
                        <v-text-field 
                          v-model="strength" 
                          placeholder=" " 
                          :rules="rules.required"
                          v-on:focus="() => {this.$vtt.startSpeechListener((text) => { this.strength = `${this.strength || ''} ${text}`;}, 'strength')}"
                          v-on:click="() => {this.$vtt.setModel('strength');}"
                          @input="setHint(strength, (replacement) => { strength = replacement })"
                          @keydown.tab="(e) => {
                            if (!getReplacement(strength)) { return true; } else { e.preventDefault(); strength = getReplacement(strength); clearReplacement(); }
                          }"
                          >
                          <template v-slot:label>
                            <h3>Strength⁄Preparation <span class="red--text">*</span></h3>
                          </template>
                        </v-text-field>
                      </v-col>

                      <!-- Quantity -->
                      <v-col cols="6" class="py-0">
                        <v-text-field 
                          v-model="quantity" 
                          type="number" 
                          placeholder=" " 
                          :rules="rules.required"
                          v-on:focus="() => {this.$vtt.startSpeechListener((text) => { this.quantity = parseInt(text); }, 'quantity')}"
                          v-on:click="() => {this.$vtt.setModel('quantity');}"
                          @input="setHint(quantity, (replacement) => { quantity = replacement })"
                          @keydown.tab="(e) => {
                            if (!getReplacement(quantity)) { return true; } else { e.preventDefault(); quantity = getReplacement(quantity); clearReplacement(); }
                          }"
                          >
                          <template v-slot:label>
                            <h3>Quantity <span class="red--text">*</span></h3>
                          </template>
                        </v-text-field>
                      </v-col>
                    </v-row>

                    <!-- Instruction -->
                    <h4>Instruction <span class="red--text">*</span></h4>

                    <v-radio-group
                      v-model="instructionType"
                    >
                      <div class="d-flex">
                        <div class="d-flex align-center">
                          <v-radio
                            value="textarea"
                          ></v-radio>
                        </div>
                        <!-- Instruction textarea -->
                        <v-row dense align="center">
                          <v-col>
                            <v-textarea
                              placeholder=" "
                              v-model="instructionAlt"
                              rows="2"
                              outlined
                              hide-details
                              :disabled="instructionType=='dropdown'"
                              v-on:focus="() => {this.instructionType = 'textarea'; this.$vtt.startSpeechListener((text) => { this.instructionAlt = `${this.instructionAlt || ''} ${text}`;}, 'instructionAlt')}"
                              v-on:click="() => {this.$vtt.setModel('instructionAlt');}"
                              @input="setHint(instructionAlt, (replacement) => { instructionAlt = replacement })"
                              @keydown.tab="(e) => {
                                if (!getReplacement(instructionAlt)) { return true; } else { e.preventDefault(); instructionAlt = getReplacement(instructionAlt); clearReplacement(); }
                              }"
                            ></v-textarea>

                            <p style="color: red;" v-if="instructionAlt.length > 200">You have reached the maximum of 200 characters</p>
                          </v-col>
                        </v-row>
                      </div>
                      <div class="d-flex">
                        <div class="d-flex align-center">
                          <v-radio
                            value="dropdown"
                          ></v-radio>
                        </div>
                        <!-- Intstruction dropdown -->
                        <v-row dense align="center" class="grey--text text--darken-1" style="font-size: .875rem;">
                          <v-col cols="2"><span :class="[{'red--text': takeEmpty}, 'font-weight-bold']">Take</span></v-col>
                          <v-col cols="1">
                            <v-text-field
                              dense
                              placeholder="#"
                              v-model="takeQuantity"
                              :rules="!instructionAlt ? rules.emptyRequired : []"
                              :disabled="instructionType=='textarea'"
                              v-on:focus="() => {this.instructionType = 'dropdown'; this.$vtt.startSpeechListener((text) => { this.takeQuantity = parseInt(text); }, 'takeQuantity')}"
                              v-on:click="() => {this.$vtt.setModel('takeQuantity');}"
                              @input="setHint(takeQuantity, (replacement) => { takeQuantity = replacement })"
                              @keydown.tab="(e) => {
                                if (!getReplacement(takeQuantity)) { return true; } else { e.preventDefault(); takeQuantity = getReplacement(takeQuantity); clearReplacement(); }
                              }"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="3">
                            <v-select
                              dense
                              placeholder="preparation"
                              :items="preparations"
                              v-model="takeLabel"
                              :disabled="instructionType=='textarea'"
                              @focus="instructionType = 'dropdown'"
                            ></v-select>
                          </v-col>
                          <v-col cols="2" class="d-flex">
                            <span :class="[{'red--text': everyEmpty}, 'font-weight-bold mx-auto']">every</span>
                          </v-col>
                          <v-col cols="1">
                            <v-text-field
                              dense
                              placeholder="#"
                              v-model="everyQuantity"
                              :rules="!instructionAlt ? rules.emptyRequired : []"
                              :disabled="instructionType=='textarea'"
                              v-on:focus="() => {this.instructionType = 'dropdown'; this.$vtt.startSpeechListener((text) => { this.everyQuantity = parseInt(text); }, 'everyQuantity')}"
                              v-on:click="() => {this.$vtt.setModel('everyQuantity');}"
                              @input="setHint(everyQuantity, (replacement) => { everyQuantity = replacement })"
                              @keydown.tab="(e) => {
                                if (!getReplacement(everyQuantity)) { return true; } else { e.preventDefault(); everyQuantity = getReplacement(everyQuantity); clearReplacement(); }
                              }"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="3">
                            <v-select
                              dense
                              placeholder="frequency"
                              :items="['hours','day(s)','week(s)']"
                              v-model="everyLabel"
                              :rules="!instructionAlt ? rules.emptyRequired : []"
                              :disabled="instructionType=='textarea'"
                              @focus="instructionType = 'dropdown'"
                            ></v-select>
                          </v-col>

                          <v-col cols="2"><span :class="[{'red--text': forEmpty}, 'font-weight-bold']">for</span></v-col>
                          <v-col cols="1">
                            <v-text-field
                              dense
                              placeholder="#"
                              v-model="forQuantity"
                              :rules="!instructionAlt ? rules.emptyRequired : []"
                              :disabled="instructionType=='textarea'"
                              v-on:focus="() => {this.instructionType = 'dropdown'; this.$vtt.startSpeechListener((text) => { this.forQuantity = parseInt(text); }, 'forQuantity')}"
                              v-on:click="() => {this.$vtt.setModel('forQuantity');}"
                              @input="setHint(forQuantity, (replacement) => { forQuantity = replacement })"
                              @keydown.tab="(e) => {
                                if (!getReplacement(forQuantity)) { return true; } else { e.preventDefault(); forQuantity = getReplacement(forQuantity); clearReplacement(); }
                              }"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="3">
                            <v-select
                              dense
                              placeholder="how long"
                              :items="['days','week(s)', 'month(s)']"
                              v-model="forLabel"
                              :rules="!instructionAlt ? rules.emptyRequired : []"
                              :disabled="instructionType=='textarea'"
                              @focus="instructionType = 'dropdown'"
                            ></v-select>
                          </v-col>
                        </v-row>
                      </div>
                      <span v-if="instructionEmpty" class="error-text">This field is required.</span>

                    </v-radio-group>
                    <VTTButton :mode="'checkbox'" />
                  </v-card-text>
                  
                  <!-- Actions -->
                  <v-card-actions class="d-flex justify-center">
                    <!-- Add/ Update Button -->
                    
                    <div v-if="medication_record_type !== 'previous'">
                      <v-btn
                        rounded
                        small
                        color="primary"
                        class="px-6 mx-2"
                        @click="saveMedication"
                      >
                        {{ medicationUpdate?'Update':'Add' }}
                      </v-btn>
                    </div>
                    
                    <div v-if="medication_record_type !== 'previous'">
                      <!-- Remove Button -->
                      <v-btn
                        rounded
                        small
                        color="error"
                        class="px-6 mx-2"
                        v-if="medicationUpdate"
                        @click="removeMedication"
                      >Remove</v-btn>
                    </div>

                    <!-- Cancel Button -->
                    <v-btn
                      rounded
                      small
                      color="primary lighten-5"
                      class="px-6 mx-2 primary--text"
                      @click="cancelMedication"
                    >
                    {{ medicationUpdate?'Close':'Cancel' }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-dialog>

    <!-- ########################################################### Recommendation Dialog ########################################################### -->

    <v-dialog v-model="recommendationDialog" content-class="elevation-0" width="70vw" max-width="700px">
      <v-form ref="recommendationForm" v-model="recommedationFormValid">
        <v-card rounded="lg" class="px-2">
          
          <v-card-title class="d-flex">
            <span class="primary--text">Recommendation</span>
            <v-btn icon class="ml-auto" @click="cancelRecommendation">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text>
            <!-- Point of Care -->
            <v-select v-model="point_of_care" :items="['Telecare','Specialist','Emergency']" placeholder=" " :rules="rules.required">
              <template v-slot:label>
                <h3>Point of Care <span class="red--text">*</span></h3>
              </template>
            </v-select>

            <!-- Time to Treat -->
            <v-select v-model="time_to_treat" :items="times" placeholder=" " :rules="rules.required">
              <template v-slot:label>
                <h3>Time to Treat <span class="red--text">*</span></h3>
              </template>
            </v-select>

            <!-- Recommended Action -->
            <v-textarea 
              v-model="recommended_action" 
              placeholder=" " 
              rows="3" 
              :rules="rules.required"
              v-on:focus="() => {this.$vtt.startSpeechListener((text) => { this.recommended_action = `${this.recommended_action || ''} ${text}`;}, 'recommended_action')}"
              v-on:click="() => {this.$vtt.setModel('recommended_action');}"
              @input="setHint(recommended_action, (replacement) => { recommended_action = replacement })"
              @keydown.tab="(e) => {
                if (!getReplacement(recommended_action)) { return true; } else { e.preventDefault(); recommended_action = getReplacement(recommended_action); clearReplacement(); }
              }"
              >
              <template v-slot:label>
                <h3>Recommended Action <span class="red--text">*</span></h3>
              </template>
            </v-textarea>

            <VTTButton :mode="'checkbox'" />

            <center>
              <h2 v-show="recommended_action.length > 1000" style="color: red;">You have reached the maximum limit of 1000 characters</h2>
            </center>

          </v-card-text>
          
          <!-- Actions -->
          <v-card-actions class="d-flex justify-center">
            <!-- Add/ Update Button -->
            
            <div v-if="recommendation_record_type !== 'previous'">
              <v-btn rounded small color="primary" class="px-6 mx-2" @click="saveRecommendation">
                {{ recommendationUpdate?'Update':'Add' }}
              </v-btn>
            </div>

            <div v-if="recommendation_record_type !== 'previous'">
              <!-- Remove Button -->
              <v-btn rounded small color="error" class="px-6 mx-2" v-if="recommendationUpdate" @click="removeRecommendation">
                Remove
              </v-btn>
            </div>

            <!-- Cancel Button -->
            <v-btn rounded small color="primary lighten-5" class="px-6 mx-2 primary--text" @click="cancelRecommendation">
              {{ recommendationUpdate?'Close':'Cancel' }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- ########################################################### Recommendation Dialog ########################################################### -->

    <hr />

  </div>
</template>

<script>
  import VTTButton from '../../../../../components/custom/VTTButton.vue'
  import MedicationProfileCard from './components/MedicationProfileCard.vue'
  import textreplacementmixin from '../../../../../mixins/textreplacementmixin';
  export default {
    name: 'FormMedication',

    mixins: [textreplacementmixin],

    components: {
      MedicineItem: () => import('./MedicineItem.vue'),
      VTTButton,
      MedicationProfileCard,
      // MostUsedPanel: () => import('./MostUsedPanel.vue'),
      FavoritesPanel: () => import('./FavoritesPanel.vue')
    },

    /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */
    
    data: () => ({
      errorMessage: "You can only create one recommendation for this case",
      strenght_quantity_error: "",
      elementVisible: false,
      preparations: [
        '',
        'capsule',
        'gel capsule',
        'caplet',
        'tablet',
        'sublingual tablet',
        'chewable tablet',
        'durule',
        'dragee',
        'effervescent tablet',
        'paper tablet',
        'ml',
        'drop⁄s',
        'lozenge',
        'sachet',
        'Nebule',
        'puff⁄s',
        'respule',
        'canister',
        'diskus',
        'MDI',
        'Rotahaler',
        'Rotacap',
        'syrup',
        'suspension',
        'oral gel',
        'oral drops',
        'ophthalmic drops',
        'otic drops',
        'cream',
        'ointment',
        'gel',
        'lotion',
        'vaginal suppository',
        'rectal suppository',
        'oral solution',
        'scalp solution',
        'solution',
        'oromucosal spray',
        'spray',
        'transdermal patch'
      ],
      instructionType: '',
      filter: '',
      isLoading: false,
      page: 1,
      isSearching: false,
      takeEmpty: false,
      everyEmpty: false,
      forEmpty: false,
      instructionEmpty: false,
      medicationFormValid: false,
      medicationDialog: false,
      recommedationFormValid: false,
      medicationUpdate: false,
      recommendationDialog: false,
      recommendationUpdate: false,
      medicationHeaders: [
        { text: 'Medicine ID', value: 'medicine_id', class:'primary--text' },
        { text: 'Brand Name', value: 'brand', class:'primary--text' },
        { text: 'Generic Name', value: 'generic', class:'primary--text' },
        { text: 'Strength', value: 'strength', class:'primary--text' },
        { text: 'Quantity', value: 'quantity', class:'primary--text' },
        { text: 'Instruction', value: 'instruction', class:'primary--text' },
        { text: 'Created On', value: 'created_on', class:'primary--text' },
        { text: 'Record Type', value: 'record_type', class:'primary--text' },
        { text: '', value: 'prescribe', class:'primary--text' }
      ],
      recommendationHeaders: [
        { text: 'Point of Care', value: 'point_of_care', class:'primary--text' },
        { text: 'Time to Treat', value: 'time', class:'primary--text' },
        { text: 'Recommended Action', value: 'recommended_action', class:'primary--text' },
        { text: 'Created On', value: 'created_on', class:'primary--text' },
        { text: 'Record Type', value: 'record_type', class:'primary--text' },
      ],
      rules: {
       required: [value => !!value || "This field is required."],
       emptyRequired: [value => !!value || ""],
      }
    }),

    /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

    watch: {
      instructionAlt(val) {
        this.instructionType = val ? 'textarea' : 'dropdown'
      },

      /* ###################################### SEPARATOR  ###################################### */

      instructionType(val) {
        switch (val) {
          case 'textarea':
            // remove content
            this.takeLabel = ''
            this.takeQuantity = ''
            this.everyLabel = ''
            this.everyQuantity = ''
            this.forLabel = ''
            this.forQuantity = ''
            // remove validation
            this.instructionEmpty = false;
            this.takeEmpty = false;
            this.everyEmpty = false;
            this.forEmpty = false;
            break;
          case 'dropdown':
            this.instructionAlt = ''
            break;
          default:
            break;
        }
      },

      /* ###################################### SEPARATOR  ###################################### */

      recommendations: function (val) {
        this.recommendations = val;
      },

      /* ###################################### SEPARATOR  ###################################### */

      medications: function (val) {
        this.medications = val;
      },

      /* ###################################### SEPARATOR  ###################################### */

      async filter(val) {
        try {
          console.log("triggering search");
          this.isLoading = true
          await this.$store.dispatch('medicine/search', val);
          this.isLoading = false
          this.page = 1
        }
        catch(e) {
          console.log('[error]', e)
          this.isLoading = false
        }
      }
    },

    /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

    computed: {
      last_page() { return this.$store.getters['medicine/last_page'] },
      consultation() { return this.$store.getters['consultation/activeInfo'] },
      medicines() { return this.$store.getters['medicine/medicines'] },
      favoriteMedicines() { return this.$store.getters['medicine/fave_medicines'] },
      mostUsedMedicines() { return this.$store.getters['medicine/used_medicines'] },
      patient() { return this.$store.getters['patient/patient'] },
      
      times() {
        var items = []
        switch (this.point_of_care) {
          case 'Telecare':
            items = ['Telecare']
            break;
          case 'Specialist':
            items = ['Within 12 hours','Within 24 hours','Next convenient appointment']
            break;
          case 'Emergency':
            items = ['Needs care now (emergency)','Very Urgent Care (0-2 hours)']
            break;
          default:
            break;
        }
        return items
      },

      
      /* ********************************************************* RECOMMENDATION DATA SET ********************************************************* */

      medication_record_type() { return this.$store.getters['medication/record_type'] },
      recommendation_record_type() { return this.$store.getters['recommendation/record_type'] },

      recommendations: {
        get() { return this.$store.getters['recommendation/recommendations'] },
        set() { this.$store.getters['recommendation/recommendations'] }
      },

      point_of_care: {
        get() { return this.$store.getters['recommendation/point_of_care'] },
        set(val) { this.$store.commit('recommendation/updatePointOfCare', val) }
      },

      time_to_treat: {
        get() { return this.$store.getters['recommendation/time_to_treat'] },
        set(val) { this.$store.commit('recommendation/updateTimeToTreat', val) }
      },

      recommended_action: {
        get() { return this.$store.getters['recommendation/recommended_action'] },
        set(val) { this.$store.commit('recommendation/updateAction', val) }
      },

      // medication data
      medications: {
        get() { return this.$store.getters['medication/medications'] },
        set() { this.$store.getters['medication/medications'] }
      },

      medicine_id: {
        get() { return this.$store.getters['medication/medicine_id'] },
        set(val) { this.$store.commit('medication/updateMedicineId', val) }
      },

      generic: {
        get() { return this.$store.getters['medication/generic'] },
        set(val) { this.$store.commit('medication/updateGeneric', val) }
      },
      brand: {
        get() { return this.$store.getters['medication/brand'] },
        set(val) { this.$store.commit('medication/updateBrand', val) }
      },
      strength: {
        get() { return this.$store.getters['medication/strength'] },
        set(val) { this.$store.commit('medication/updateStrength', val) }
      },
      quantity: {
        get() { return this.$store.getters['medication/quantity'] },
        set(val) { this.$store.commit('medication/updateQuantity', val) }
      },
      instructionAlt: {
        get() { return this.$store.getters['medication/instructionAlt'] },
        set(val) { this.$store.commit('medication/updateInstructionAlt', val) }
      },
      takeQuantity: {
        get() { return this.$store.getters['medication/takeQuantity'] },
        set(val) {
          this.$store.commit('medication/updateTakeQuantity', val)
          this.takeEmpty = !val ? true : false;
          // this.takeEmpty = (!val || !this.takeLabel) ? true : false;
        }
      },

      takeLabel: {
        get() { return this.$store.getters['medication/takeLabel'] },
        set(val) {
          this.$store.commit('medication/updateTakeLabel', val);
          // this.takeEmpty = (!val || !this.takeQuantity) ? true : false;
        }
      },

      everyQuantity: {
        get() { return this.$store.getters['medication/everyQuantity'] },
        set(val) {
          this.$store.commit('medication/updateEveryQuantity', val);
          this.everyEmpty = (!val || !this.everyLabel) ? true : false;
        }
      },

      everyLabel: {
        get() { return this.$store.getters['medication/everyLabel'] },
        set(val) {
          this.$store.commit('medication/updateEveryLabel', val);
          this.everyEmpty = (!val || !this.everyQuantity) ? true : false;
        }
      },

      forQuantity: {
        get() { return this.$store.getters['medication/forQuantity'] },
        set(val) {
          this.$store.commit('medication/updateForQuantity', val);
          this.forEmpty = (!val || !this.forLabel) ? true : false;
        }
      },
      forLabel: {
        get() { return this.$store.getters['medication/forLabel'] },
        set(val) {
          this.$store.commit('medication/updateForLabel', val);
          this.forEmpty = (!val || !this.forQuantity) ? true : false;
        }
      },

      comment: {
        get() { return this.$store.getters['medication/comment'] },
        set(val) { this.$store.commit('medication/updateComment', val) }
      }
    },

    /* ********************************************************* RECOMMENDATION DATA SET ********************************************************* */

    async mounted() {
      await this.$store.dispatch('medicine/fetchMedicines', {per_page: 10, page: this.page});
    },

    /* ********************************************************* RECOMMENDATION DATA SET ********************************************************* */

    methods: {
      setCode (val) {
        let string = val.trim().replace('.', '');
        this.filter = string;
        console.log(string);
      },

      async togglePage(type) {
        console.log("[filter]", this.filter);
        
        let params = {};

        if(this.filter != null && this.filter.length > 0) {
          params = {per_page: 10, page: this.page, search: this.filter};
        } else {
          params = {per_page: 10, page: this.page};
        }

        console.log("[params]", params);

        if (type=='next') {
          if(this.last_page > this.page) {
            this.page++;
            params.page++;
            await this.$store.dispatch('medicine/fetchMedicines', params);
          }
        }
        else {
          this.page--;
          params.page--;
          await this.$store.dispatch('medicine/fetchMedicines', params);
        }
      },

      /* ###################################### SEPARATOR  ###################################### */

      filterObject(item, queryText) {
        return (
          item.generic_name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 ||
          item.brand_name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
        );
      },

      /* ###################################### SEPARATOR  ###################################### */

      setSelected(item, origin) {
        this.filter = '';
        this.medicine_id = item.id;
        this.autoFillDetails(origin);
        this.$refs.medicineAutoComplete.blur()
        console.log('reference', this.$refs.medicineAutoComplete);
      },

      /* ###################################### SEPARATOR  ###################################### */

      addMedication() {
        this.$store.commit('medication/clear');
        this.medicine_id = null;
        this.medicationUpdate = false;
        this.medicationDialog = true;
        this.isSearching = false;
      },

      /* ###################################### SEPARATOR  ###################################### */

      updateMedication(index) {
        this.medicationUpdate = true;
        this.medicationDialog = true;
        this.$store.commit('medication/setActive', index);
      },

      /* ###################################### SEPARATOR  ###################################### */

      cancelMedication() {
        this.resetMedicationForm();
        this.medicationDialog = false;
        this.medicationUpdate = false;
      },

      /* ###################################### SEPARATOR  ###################################### */

      resetMedicationForm() {
        this.$refs.medicationForm.resetValidation();
        this.instructionEmpty = false;
        this.takeEmpty = false;
        this.everyEmpty = false;
        this.forEmpty = false;
      },

      /* ###################################### SEPARATOR  ###################################### */

      validateMedicationForm() {
        this.$refs.medicationForm.validate();
        var items = ['takeLabel', 'takeQuantity', 'everyLabel', 'everyQuantity', 'forLabel', 'forQuantity'];
        this.instructionEmpty = items.find(item => !this[item]) && !this.instructionAlt;
        if (this.instructionEmpty) {
          this.takeEmpty = !this.takeQuantity ? true : false;
          this.everyEmpty = (!this.everyLabel || !this.everyQuantity) ? true : false;
          this.forEmpty = (!this.forLabel || !this.forQuantity) ? true : false;
        }
      },

      /* ###################################### SEPARATOR  ###################################### */

      saveMedication() {
        this.validateMedicationForm();
        if(this.instructionAlt.length > 200) {
          return false;
        }

        if(this.strength.trim().length == 0 || this.quantity.length == 0) {
          this.strenght_quantity_error = "Please make sure that both strength and quantity has a value";
          return false;
        } else {
          this.strenght_quantity_error = "";
        }

        if (this.medicationFormValid) {
          if (this.medicationUpdate) {
            var index = this.$store.getters['medication/active'];
            this.$store.commit('medication/edit', index);
          }
          else
            this.$store.commit('medication/add');

          this.$store.commit('medication/clear');
          this.medicationDialog = false;
          this.resetMedicationForm();
        }
      },

      /* ###################################### SEPARATOR  ###################################### */

      removeMedication() {
        this.$store.commit('medication/remove');
        this.medicationDialog = false;
      },

      /* ###################################### SEPARATOR  ###################################### */

      // recommendation
      addRecommendation() {
        let current_created_recommendations = this.recommendations.filter(item_instance => { if (item_instance.record_type == 'current') return item_instance}).length;
        if(current_created_recommendations > 0) {
          this.elementVisible = true;
          setTimeout(() => this.elementVisible = false, 5000);
          return false;
        }

        this.$store.commit('recommendation/clear');
        this.recommendationUpdate = false;
        this.recommendationDialog = true;
      },

      /* ###################################### SEPARATOR  ###################################### */

      updateRecommendation(index) {
        this.recommendationUpdate = true;
        this.recommendationDialog = true;
        this.$store.commit('recommendation/setActive', index);
      },

      /* ###################################### SEPARATOR  ###################################### */

      cancelRecommendation() {
        this.$refs.recommendationForm.resetValidation();
        this.recommendationDialog = false;
        this.recommendationUpdate = false;
      },

      /* ###################################### SEPARATOR  ###################################### */

      saveRecommendation() {
        this.$refs.recommendationForm.validate();

        if(this.recommended_action.length > 1000) {
          return false;
        }

        if (this.recommedationFormValid) {
          if (this.recommendationUpdate) {
            var index = this.$store.getters['recommendation/active'];
            this.$store.commit('recommendation/edit', index);
          }
          else
            this.$store.commit('recommendation/add');

          this.$store.commit('recommendation/clear');
          this.recommendationDialog = false;
        }
      },

      /* ###################################### SEPARATOR  ###################################### */

      removeRecommendation() {
        this.$store.commit('recommendation/remove');
        this.recommendationDialog = false;
      },

      /* ###################################### SEPARATOR  ###################################### */

      autoFillDetails(origin = '') {
        let index;
        let c;
        if (this.medicine_id) {

          switch (origin) {
            case 'fav':
              index = this.favoriteMedicines.findIndex(item => item.id == this.medicine_id)  
              c = this.favoriteMedicines[index]
              break;
          
            case 'used':
              index = this.mostUsedMedicines.findIndex(item => item.id == this.medicine_id)  
              c = this.mostUsedMedicines[index]
              break;

            default: 
              index = this.medicines.findIndex(item => item.id == this.medicine_id); 
              c = this.medicines[index]
              break;
          }
        
          console.log(index);
          console.log(c);
          
          if (index >= 0) {
            this.brand = c.brand_name
            this.generic = c.generic_name
            this.strength = c.strength
          }
        }
        else {
          this.description = ''
        }
      },

      /* ###################################### SEPARATOR  ###################################### */
      
      // medication search
      addToMostUsed() {
        this.autoFillDetails()

        let index = this.medicines.findIndex(
          item => item.id == this.medicine_id
        )
        if (index >= 0) {
          // this.$store.commit('medicine/addToMostUsed', this.medicines[index])
        }
      }
    }
  }
</script>

<style lang="scss">
.v-autocomplete__content {
  min-height: 362px;
}
</style>

<style scoped>
.v-table-max-width {
  max-width: 430px;
}
</style>